import SmsSendingStartSettingsTab from "./SmsSendingStartSettingsTab"
import styles from "./SmsSendingStartSettingsTab.module.scss"

import { useSouhlAdminQuery } from "@/provider/apollo/Apollo"
import { graphql } from "@/souhl_admin/gql/__generated__"

const getCompanyQuery = graphql(/* GraphQL */ `
	query getCompanyForSmsSendingStartSettings($param: CompanyParam!) {
		company(param: $param) {
			currentCompany: company {
				salons {
					...smsSendingStartSettings
				}
			}
		}
	}
`)

type SmsSendingStartSettingsTabContainerProps = {
	companyId: string
}

const SmsSendingStartSettingsTabContainer = ({
	companyId,
}: SmsSendingStartSettingsTabContainerProps) => {
	const { data, refetch: refetchCompany } = useSouhlAdminQuery(
		getCompanyQuery,
		{
			variables: { param: { id: companyId } },
			fetchPolicy: "no-cache",
		}
	)

	const fragments = data?.company?.currentCompany?.salons || []

	return (
		<div className={styles.tab_inner_content}>
			{fragments.length > 0 ? (
				<SmsSendingStartSettingsTab
					companyId={companyId}
					fragment={fragments}
					onUpdated={refetchCompany}
				/>
			) : (
				<div>店舗がありません。</div>
			)}
		</div>
	)
}

export default SmsSendingStartSettingsTabContainer
